import React, { useState, useEffect } from 'react';
import Panel from './Panel';
import useGlobal from '../../store';
import EditItemForm from '../Forms/EditItemForm';
import Spinner from '../General/Spinner';

const EditItem = (props) => {

    const [isLoading, setIsLoading] = useState(false);

    const [panel, uiActions] = useGlobal(
        state => state.ui.sidepanel,
        actions => actions.uiActions
    );

    const [response, giftlistActions] = useGlobal(
        state => state.response,
        actions => actions.giftlistActions
    );

    const closePanel = () => {
        uiActions.closeSidePanel();
    }

    const handleEditItemFormSubmit = (formData) => {
        console.log('EDITING ITEM....', formData);
        setIsLoading(true);
        giftlistActions.updateItem(formData);
    }

    useEffect(() => {
        if(!response || response.type !== "updateitem" || panel.name !== "edititem") {
            return;
        }
        console.log('GOT A RESPONSE!', response);
        setIsLoading(false);
        uiActions.closeSidePanel();
        uiActions.clearResponse();
    }, [response, uiActions, panel.name]);
    return (
        <Panel open={props.open && panel.name === "edititem"}>
            {props.name === "edititem" ?
                <>
                <div className="kt-offcanvas-panel__nav bg-white mb-0" kt-hidden-height="77">
                    <h3>Edit Item</h3>
                    <button className="kt-offcanvas-panel__close" id="kt_quick_panel_close_btn" onClick={() => closePanel()}><i className="flaticon2-delete"></i></button>
                </div>
                <div className="kt-offcanvas-panel__nav bg-white">
                    {panel.state.itemPic ? <img alt="item" src={panel.state.itemPic} className="mr-2" style={{height: "40px"}} /> : <></> }
                    <p className="text-ellipsis">{panel.state.itemName}</p>
                </div>
                <div className="kt-offcanvas-panel__body">
                    <div className="tab-content">
                        <div className="tab-pane fade show kt-offcanvas-panel__content kt-scroll active ps ps--active-y" id="kt_quick_panel_tab_notifications" role="tabpanel" >

                            {isLoading ? <Spinner></Spinner> : <EditItemForm submitForm={handleEditItemFormSubmit}></EditItemForm> }
                        
                        </div>
                    </div>
                </div>
                </> : <></>}
        </Panel>

    );
}

export default EditItem;